export var Suffixes;
(function (Suffixes) {
    Suffixes["EUROS"] = " \u20AC";
    Suffixes["KILO_EUROS"] = " K\u20AC";
    Suffixes["JOURS"] = " j";
    Suffixes["POURCENTAGE"] = " %";
    Suffixes["MOIS"] = " mois";
    Suffixes["ANS"] = " ans";
    Suffixes["AN"] = " an";
    Suffixes["NONE"] = "";
})(Suffixes || (Suffixes = {}));
export const eurosSuffix = (isKiloEuros) => isKiloEuros ? Suffixes.KILO_EUROS : Suffixes.EUROS;
export const anneeSuffix = (value) => (value > 1 ? Suffixes.ANS : Suffixes.AN);
//# sourceMappingURL=suffixes.js.map